import Area from "./Area";
import Department from "./Department";
import TransportType from "./TransportType";
import FeesType from "./FeesType";
import FeesSetup from "./FeesSetup";
import TransactionCodeSetup from "./TransactionCodeSetup";
import ClassPromotion from "./ClassPromotion";
import FinanceTransactionCodeSetup from "./FinanceTransactionCodeSetup";
import ModeOfPay from "./ModeOfPay";
import Currency from "./Currency";
import Customer from "./Customer";
import Supplier from "./Supplier";
import AccountLedger from "./AccountLedger";
import Zone from "./Zone";
import BankDetail from "./BankDetail";
import CashLedger from "./CashLedger";
import BusDetail from "./BusDetail";
import AcademicYear from "./AcademicYear";
import Grade from "./Grade";
import Term from "./Term"
import MainGroupLedger from "./MainGroupLedger";
interface ConfigServiceProps {
    name: string;
    id: number;
    onClose: () => void;
}

const ConfigService = ({ name, id, onClose }: ConfigServiceProps) => {
    if (name === "Area") {
        return <Area onClose={() => onClose()} id={id} />
    }
    if (name === "Department") {
        return <Department onClose={() => onClose()} id={id} />
    }
    if (name === "Transport Type") {
        return <TransportType onClose={() => onClose()} id={id} />
    }
    if (name === "Fees Type") {
        return <FeesType onClose={() => onClose()} id={id} />
    }
    if (name === "Fees Setup") {
        return <FeesSetup onClose={() => onClose()} id={id} />
    }
    if (name === "Transaction Code Setup") {
        return <TransactionCodeSetup onClose={() => onClose()} id={id} />
    }
    if (name === "Finance Transaction Code Setup") {
        return <FinanceTransactionCodeSetup onClose={() => onClose()} id={id} />
    }
    if (name === "Mode Of Pay") {
        return <ModeOfPay onClose={() => onClose()} id={id} />
    }
    if (name === "Currency") {
        return <Currency onClose={() => onClose()} id={id} />
    }
    if (name === "Customer") {
        return <Customer onClose={() => onClose()} id={id} />
    }
    if (name === "Supplier") {
        return <Supplier onClose={() => onClose()} id={id} />
    }
    if (name === "Account Ledger") {
        return <AccountLedger onClose={() => onClose()} id={id} />
    }
    if (name === "Zone") {
        return <Zone onClose={() => onClose()} id={id} />
    }
    if (name === "Cash Ledger") {
        return <CashLedger onClose={() => onClose()} id={id} />
    }
    if (name === "Bank Detail") {
        return <BankDetail onClose={() => onClose()} id={id} />
    }
    if (name === "Class Promotion") {
        return <ClassPromotion onClose={() => onClose()} id={id} />
    }
    if (name === "Bus Detail") {
        return <BusDetail onClose={() => onClose()} id={id} />
    }
    if (name === "Calendar Mgmt") {
        return <AcademicYear onClose={() => onClose()} id={id} />
    }
    if (name === "Class") {
        return <Grade onClose={() => onClose()} id={id} />
    }
    if (name === "Term") {
        return <Term onClose={() => onClose()} id={id} />
    }
    if (name === "Main Group Ledger") {
        return <MainGroupLedger onClose={() => onClose()} id={id} />
    }
}
export default ConfigService;